import script from "./UploadingView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadingView.vue?vue&type=script&setup=true&lang=ts"

import "./UploadingView.vue?vue&type=style&index=0&id=14eaab04&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\iab_b\\Documents\\Dev\\OA\\woah-transfer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14eaab04"]])

export default __exports__